import type {AppendixCode, AppendixDefinition} from './types';
import {APP1_DEF} from './app1';
import {APP2_DEF} from './app2';
import {APP3_DEF} from './app3';
import {APP5_DEF} from './app5';
import {APP6_DEF} from './app6';

export type {AppendixCode, AppendixDefinition, AppendixIndexRow, AppendixTablePage} from './types';

export const ALL_APPENDIX_DEFS: AppendixDefinition[] = [
    APP1_DEF,
    APP2_DEF,
    APP3_DEF,
    APP5_DEF,
    APP6_DEF,
];

export const APPENDIX_BY_CODE: Record<AppendixCode, AppendixDefinition> = {
    '1': APP1_DEF,
    '2': APP2_DEF,
    '3': APP3_DEF,
    '5': APP5_DEF,
    '6': APP6_DEF,
};

export function getAppendixDef(code: string): AppendixDefinition | undefined {
    return APPENDIX_BY_CODE[code as AppendixCode];
}

export const APPENDIX_SECTION_CODES = ALL_APPENDIX_DEFS.map((d) => d.sectionCode);

export function isAppendixSectionCode(sectionCode: string): boolean {
    return APPENDIX_SECTION_CODES.includes(sectionCode.toUpperCase());
}
